// extracted by mini-css-extract-plugin
export default {"modal":"MovieDetails_modal__lcDQr","overlay":"MovieDetails_overlay__32YFs","content":"MovieDetails_content__VJ4g2"};